import { createSlice } from "@reduxjs/toolkit";
import { userAuthApi } from "../services/userAuthApi";
import { getToken } from "../services/localStorageService";

const initialState = {
  token: getToken(),
  user: null,
};

export const authSlice = createSlice({
  name: "authInfo",
  initialState,
  reducers: {
    setAuthTokens: (state, action) => {
      state.token = action.payload.token;
      state.user = action.payload.user;
    },
    clearAuthTokens: (state) => {
      state.token = null;
      state.user = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(
        userAuthApi.endpoints.loginUser.matchFulfilled,
        (state, { payload }) => {
          state.user = payload.data;
          state.token = payload.data.api_token;
        }
      )
      .addMatcher(userAuthApi.endpoints.loginUser.matchRejected, (state) => {
        state.user = null;
        state.token = null;
      });
  },
});

export const { setAuthTokens, clearAuthTokens } = authSlice.actions;

export default authSlice.reducer;
